import { render, staticRenderFns } from "./date-field.vue?vue&type=template&id=156423e0&scoped=true&lang=pug&"
import script from "./date-field.vue?vue&type=script&lang=js&"
export * from "./date-field.vue?vue&type=script&lang=js&"
import style0 from "./date-field.vue?vue&type=style&index=0&id=156423e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156423e0",
  null
  
)

export default component.exports